import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useSteps } from '../../hooks';
import DeleteStep from '../DeleteStep';
import Menu from '../../ui/Menu';
import MenuItem from '../../ui/Menu/MenuItem';

const StepTypes = {
  DELETE: 'DELETE',
};

const ActionsStep = React.memo(({ relation, onNameEdit, onDelete, onClose }) => {
  const [t] = useTranslation();
  const [step, openStep, handleBack] = useSteps();

  const handleEditNameClick = useCallback(() => {
    onNameEdit();
    onClose();
  }, [onNameEdit, onClose]);

  const handleDeleteClick = useCallback(() => {
    openStep(StepTypes.DELETE);
  }, [openStep]);

  if (step && step.type === StepTypes.DELETE) {
    return (
      <DeleteStep
        title="common.deleteRelation"
        content="common.areYouSureYouWantToDeleteThisRelation"
        contentValues={{ name: relation.card.name }}
        buttonContent="action.deleteRelation"
        onConfirm={onDelete}
        onBack={handleBack}
      />
    );
  }

  return (
    <Menu>
      {/* <MenuItem icon="edit" onClick={handleEditNameClick}>
        {t('action.edit')}
      </MenuItem> */}
      <MenuItem icon="delete" onClick={handleDeleteClick}>
        {t('action.deleteRelation', {
          context: 'title',
        })}
      </MenuItem>
    </Menu>
  );
});

ActionsStep.propTypes = {
  relation: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onNameEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActionsStep;
